// ops — второй iPhone-виджет: неделя по проектам (Scriptable).
// GET /api/ops/widget-week у weern-ops, тот же Bearer OPS_WIDGET_TOKEN.
// week = скользящие последние 7 суток; total = «Всего» (режим по тапу):
// javelin — за итерацию '1000', остальные — общий итог.
import { z } from 'zod';

const metric = z.object({
  week: z.number(),
  total: z.number(),
  last_at: z.string().nullable(), // ISO последнего события или null
});

export const OpsWidgetWeekResSchema = z.object({
  generated_at: z.string(),
  eyeq: metric,    // отгружено
  pothos: metric,  // отгружено (total = каталог pothos_assets, shipped-статусы)
  javelin: metric, // снято (total = итерация '1000')
  kids: metric,    // снято
});
export type OpsWidgetWeekRes = z.infer<typeof OpsWidgetWeekResSchema>;
